import { render, staticRenderFns } from "./DecimalInput.vue?vue&type=template&id=f2d3dca6"
import script from "./DecimalInput.ts?vue&type=script&lang=ts&external"
export * from "./DecimalInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports